import styled from "styled-components";
export const Para=styled.p`
    line-height: 24px;
    color: #000000;
    margin-bottom: 24px;
    font-size:16px;

`
